import { Job } from './api';

export function toJobSlug(
  { location, title, id }: Job,
  boardId: string
): { slug: string; query: Record<string, string> } {
  return {
    slug: `/careers/${slugged(location)}/${slugged(title)}-${boardId}-${id}`,
    query: { gh_jid: id.toString() },
  };
}

function slugged(field: string): string {
  return field
    .toLowerCase()
    .replace(/[\W_]+/g, '+') // Replace groups of special characters with plus sign
    .replace(/^\+/, '') // If plus sign is at beginning, remove it
    .replace(/\+$/, ''); // If plus sign is at end, remove it
}
